export const RESET = 'TICKER/RESET'
export const SET_SUBSCRIBED = 'TICKER/SET_SUBSCRIBED'
export const SET_UPDATE = 'TICKER/SET_UPDATE'
export const STOP = 'TICKER/STOP'
export const SNAPSHOT = 'TICKER/SNAPSHOT'
